import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { MatSortModule } from '@angular/material/sort';
import * as fromGuards from '../store/guards';
import { effects } from '../store';
import { SharedModule } from '../shared/shared.module';
import { ManageUsersComponent } from './manage-users.component';
import * as fromPortalRoleReducer from '../store/reducers/portal-roles.reducer';
import * as fromUsersReducer from '../store/reducers/users.reducer';
import { CreateEditUserDialogComponent } from './dialogs/create-edit-user-dialog.component';
import { ConfirmDeactivateUserDialogComponent } from './dialogs/confirm-deactivate-user-dialog.component';
import { OnboardingOktaUserComponent } from './onboarding-okta-user/onboarding-okta-user.component';
import { ChangePasswordDialogComponent } from './dialogs/change-password-dialog.component';

@NgModule({
  imports: [
    SharedModule,
    RouterModule,
    ManageUsersComponent,
    OnboardingOktaUserComponent,
    CreateEditUserDialogComponent,
    ChangePasswordDialogComponent,
    MatSortModule,
    ConfirmDeactivateUserDialogComponent,
    StoreModule.forFeature('user', fromUsersReducer.reducer),
    StoreModule.forFeature('portalRoles', fromPortalRoleReducer.reducer),
    EffectsModule.forFeature(effects),
  ],
  declarations: [],
  providers: [],
})
export class ManageUsersModule {}
